import { render, staticRenderFns } from "./ConfirmSimple.vue?vue&type=template&id=48869bcc&scoped=true&"
import script from "./ConfirmSimple.vue?vue&type=script&lang=js&"
export * from "./ConfirmSimple.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmSimple.vue?vue&type=style&index=0&id=48869bcc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48869bcc",
  null
  
)

export default component.exports